module.exports = __webpack_public_path__ + "static/media/miniraknare.bf0ee64e.mp3";